export default __webpack_public_path__ + "images/14_habitat.jpg";